import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

/**
 * Resolves a referral code to the referrer's user ID
 */
const useReferrerIdFromCode = (referralCode?: string) => {
  const queryResult = useQuery({
    queryKey: ["referrer-id-from-code", referralCode],
    queryFn: async () => {
      if (!referralCode) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select(`id`)
        .eq("referral_code", referralCode)
        .maybeSingle();

      if (error) {
        console.error("Error resolving referral code:", error);
        return null;
      }

      return data?.id || null;
    },
    enabled: !!referralCode,
  });

  return queryResult;
};

export default useReferrerIdFromCode;
